export type ModuleName =
  | 'dashboard'
  | 'action-plan'
  | 'catalog'
  | 'agenda'
  | 'team'
  | 'arquivos'
  | 'crm'
  | 'shows'
  | 'marketing'
  | 'releases'
  | 'unknown';

export interface ActiveModuleContext {
  module: ModuleName;
  artistId: string | null;
  artistName: string | null;
  rawPath: string;
}

/**
 * Mapeamento de segmentos de rota para nomes de módulo.
 * Pattern: /artists/:id/:segment
 */
export const ROUTE_TO_MODULE: Record<string, ModuleName> = {
  'action-plan': 'action-plan',
  'catalog': 'catalog',
  'agenda': 'agenda',
  'team': 'team',
  'arquivos': 'arquivos',
  'crm': 'crm',
  // O endereço que o artista vê é em português, como `arquivos` e `perfil`. `crm` fica de pé
  // porque já significa o CRM interno em `/admin/crm`, e um endereço publicado não se corta.
  'negociacoes': 'crm',
  'shows': 'shows',
  // Na web o CRM e os Shows moram em /vendas e /producao (o Controle de shows, 27/09/2026).
  'vendas': 'crm',
  'producao': 'shows',
  // Meus modelos serve ao Shows (elenco, formações) e ao CRM (produtos); fica com o Shows no
  // mapa porque é por lá que se entra.
  'modelos': 'shows',
  'marketing': 'marketing',
  'releases': 'releases',
  'lancamentos': 'releases',
  'commercial': 'crm',
  'wizard': 'dashboard',
  'nyta': 'dashboard',
};

/**
 * Resolve o módulo ativo a partir do pathname.
 * Pattern esperado: /artists/:id ou /artists/:id/:segment
 *
 * - Sem segmento → 'dashboard'
 * - Segmento conhecido → módulo correspondente
 * - Segmento desconhecido → 'unknown' com rawPath
 */
export function resolveModuleFromPath(pathname: string): {
  module: ModuleName;
  artistId: string | null;
  rawPath: string;
} {
  const match = pathname.match(/\/artists\/([^/]+)(?:\/([^/]+))?/);

  if (!match) {
    return { module: 'unknown', artistId: null, rawPath: pathname };
  }

  const [, artistId, segment] = match;

  if (!segment) {
    return { module: 'dashboard', artistId, rawPath: pathname };
  }

  const module = ROUTE_TO_MODULE[segment] ?? 'unknown';
  return { module, artistId, rawPath: pathname };
}
